import { render, staticRenderFns } from "./Sort.vue?vue&type=template&id=47e0755c"
import script from "./Sort.vue?vue&type=script&lang=js"
export * from "./Sort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/wp-content/themes/svea/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47e0755c')) {
      api.createRecord('47e0755c', component.options)
    } else {
      api.reload('47e0755c', component.options)
    }
    module.hot.accept("./Sort.vue?vue&type=template&id=47e0755c", function () {
      api.rerender('47e0755c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/Sort.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Sort.vue
// module id = 17
// module chunks = 0